import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import styles from "../styles/Breadcrumbs.module.css";

const PATH_TITLES = {
  admin: "Dashboard",
  users: "Users Management",
  posts: "Posts Management",
  reportedusers: "Reported Users",
  reports: "Reported Posts",
  AddSighting: "Add Sighting",
  analytics: "Analytics",
  referrals: "Referrals",
  account: "Account",
};

const Breadcrumbs = () => {
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean);

  if (
    segments.length === 0 ||
    (segments.length === 1 && ["login", "signup"].includes(segments[0]))
  ) {
    return null;
  }

  return (
    <nav className={styles.breadcrumbs} aria-label="Breadcrumb">
      <Link to="/" className={styles.breadcrumbLink}>
        <FontAwesomeIcon icon={faHome} /> Home
      </Link>

      {segments.map((segment, index) => {
        const path = `/${segments.slice(0, index + 1).join("/")}`;
        const isLast = index === segments.length - 1;
        const isUserProfile =
          segments[0] === "analytics" &&
          segments[1] === "users" &&
          index === 2;
        const title = isUserProfile
          ? "User Profile"
          : PATH_TITLES[segment] || segment;

        return (
          <React.Fragment key={path}>
            <span className={styles.separator}>
              <FontAwesomeIcon icon={faChevronRight} />
            </span>
            {isLast ? (
              <span className={styles.current} aria-current="page">
                {title}
              </span>
            ) : (
              <Link to={path} className={styles.breadcrumbLink}>
                {title}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
